/** Plain, single-line excerpts. Never expose a wire-format mention in the UI. */
export function replyPreview(body:string, userName:(id:string)=>string, limit=160):string {
 const text=body.replace(/<@([0-9a-f-]{36})>/gi,(_,id)=>'@'+userName(id))
  .replace(/<a?:([a-z0-9_]{2,32}):[0-9a-f-]{36}>/gi,(_,name)=>':'+name+':')
  .replace(/\s+/gu,' ').trim();
 const points=Array.from(text);
 return points.length>limit?points.slice(0,limit).join('')+'…':text;
}
